import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './error.css';

const Error500: React.FC = () => {
    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <div className="error-page text-center">
                <h1 className="display-4 text-danger">500 - Server Error</h1>
                <p className="lead">Something went wrong on the server. Please try again later.</p>
            </div>
        </div>
    );
};

export default Error500;
